
import React from 'react';
import { Link } from 'react-router-dom';

const Legal: React.FC = () => {
  return (
    <div className="min-h-screen relative">
      {/* Background Image with Blur */}
      <div 
        className="fixed inset-0 bg-fixed bg-cover bg-center z-0"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')" }}
      >
        <div className="absolute inset-0 bg-white/40 backdrop-blur-[10px]"></div>
      </div>

      <div className="relative z-10 py-20 px-4">
        <div className="max-w-4xl mx-auto bg-white/95 backdrop-blur-sm rounded-3xl p-10 shadow-xl border border-white/50">
            <h1 className="text-4xl font-bold text-navy mb-8 border-b border-gray-200 pb-4">Mentions Légales</h1>

            <section className="mb-8">
                <h2 className="text-2xl font-bold text-navy mb-4">Informations en cours de finalisation</h2>
                <p className="text-gray-700 text-lg leading-relaxed">
                    Nos mentions légales détaillées sont actuellement en cours de rédaction et seront disponibles prochainement.
                </p>
            </section>

            <section className="mb-10">
                <h2 className="text-2xl font-bold text-navy mb-4">Informations de contact</h2>
                <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100">
                    <p className="mb-2"><strong className="text-navy">Entreprise :</strong> Le Démarcheur Facilitateur (LDF)</p>
                    <p className="mb-2"><strong className="text-navy">Email :</strong> <a href="mailto:ledemarcheur@lefacilitateur.online" className="text-orange hover:underline">ledemarcheur@lefacilitateur.online</a></p>
                    <p><strong className="text-navy">Téléphone :</strong> +229 01 97 40 67 67</p>
                </div>
            </section>
            
            <hr className="border-gray-200 mb-8"/>

            <p className="text-gray-600 mb-8">
                Pour toute question d'ordre légal ou administratif, n'hésitez pas à nous contacter via les coordonnées ci-dessus.
            </p>

            <div className="text-center">
                <Link to="/" className="inline-block bg-orange text-white font-bold py-3 px-8 rounded-xl hover:bg-orange/90 transition shadow-lg">
                    Retour à l'accueil
                </Link>
            </div>
        </div>
      </div>
    </div>
  );
};

export default Legal;
